<template>
    <el-form class="flex-form"
            v-loading="initLoading"
            ref="refForm"
            :id="refForm"
            :disabled="isForceDisplay"
            :model="formData"
            :label-width="labelWitdh"
            :action="action"
            method="post"
            :label-position="formItemPosition"
            enctype="multipart/form-data"
            status-icon
            size="large">
            <div class="from-header" ref="header">
                <div v-if="isShowHead">
                    <span>{{ headName }}</span>
                    <el-select 
                        v-if="isFlow && flowNodes.length > 1"
                        class="nodeSelect"
                        v-model="requestCurrentNodeId" @change="changeFlowNode">
                        <el-option
                            v-for="item in flowNodes"
                            :key="item.Value"
                            :label="item.Text"
                            :value="item.Value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="form-body" ref="body" :style="formBodyStyle">
                <el-scrollbar>
                    <el-row>
                        <component v-for="(field,index) in layout"
                                :key="field.Name"
                                :is="field.FieldDefinition.Name"
                                :definition="field"
                                :data="formData"
                                :contentType="requestContentType"
                                :htmlPrefix="htmlPrefix"
                                :formDefinition = "formDefinition"
                                :orginalDisplay = "orginalDisplay">
                        </component>
                    </el-row>
                </el-scrollbar>
                <input name="BackOff" :value="backOffValue" hidden="hidden" />
                <input name="HandOver" :value="handOverValue" hidden="hidden" />
            </div>
            <div class="form-footer" ref="foot" v-if="showButton">
                <div class="buttonGroup" v-if="!isForceDisplay">
                    <el-button type="success" 
                            v-if="commomButtons.Publish.Switch"
                            :disabled="buttonRequestState"
                            :loading="buttonLoading.Submit"
                            @click="publishForm">
                            {{ commomButtons.Publish.ButtonName }}
                    </el-button>

                    <el-button type="primary" 
                            v-if="commomButtons.Draft.Switch"
                            :disabled="buttonRequestState"
                            :loading="buttonLoading.Draft"
                            @click="draftForm">
                            {{ commomButtons.Draft.ButtonName }}
                    </el-button>

                    <el-button type="primary"
                            v-if="commomButtons.HandOver.Switch"
                            :disabled = "buttonRequestState">
                            {{ commomButtons.HandOver.ButtonName }}
                    </el-button>
                    <el-button type="primary"
                            @click="backOffForm"
                            v-if="commomButtons.BackOff.Switch"
                            :loading="buttonLoading.BackOff"
                            :disabled = "buttonRequestState">
                            {{ commomButtons.BackOff.ButtonName }}
                    </el-button>
                    <el-button type="danger"
                            v-if="commomButtons.End.Switch"
                            :loading="buttonLoading.End"
                            :disabled = "buttonRequestState">
                            {{ commomButtons.End.ButtonName }}
                    </el-button>

                    <el-button type="primary"
                            v-for="(button,index) in previewList"
                            @click="previewForm(button)"
                            :key="index"
                            v-show="button.showState">
                            {{ button.ButtonName }}
                    </el-button> 

                    <div v-if="saveLocal.Switch">
                        <el-checkbox v-model="frontEndSaveValue">保存本次提交内容，下次自动填充</el-checkbox>
                    </div>
                </div>
                <div class="form-footer buttonGroup" v-else>
                    <el-button v-if="commomButtons.ReCall.Switch"
                            :loading="buttonLoading.reCall"
                            :disabled = "buttonRequestState"
                            type="primary"
                            icon="el-icon-back">
                        {{ commomButtons.ReCall.ButtonName }}
                    </el-button>
                    <el-button type="primary"
                            v-for="(button,index) in previewList"
                            @click="previewForm(button)"
                            :key="index"
                            v-show="button.showState">
                            {{ button.ButtonName }}
                    </el-button> 
                </div>
            </div>
            <el-dialog
                v-model="backOffModalDisplay"
                title="回退"
                width="30%">
                <el-radio-group v-model="backOffValue">
                    <el-radio v-for="item in backOffOptions"
                        :key="item.value"
                        :value="item.value"
                        :label="item.value">
                        {{ item.text }}
                    </el-radio>
                </el-radio-group>
                <template #footer>
                    <span class="dialog-footer">
                        <el-button @click="backOffModalDisplay = false" :disabled = "buttonRequestState">取消</el-button>
                        <el-button type="primary" @click="bcakOffModal" :loading="buttonLoading.BackOff">回退</el-button>
                    </span>
                </template>
            </el-dialog>
    </el-form>
</template>

<style>
    .flex-form{
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .form-body{
        flex: 1;
        overflow-y: auto;
    }

    .el-form-item{
        padding-left: 12px;
        padding-right: 12px;
    }

    .nodeSelect .el-input__inner{
        border: 0px !important;
    }

    @media only screen and (max-width: 768px) {
        .el-form--large.el-form--label-top .el-form-item .el-form-item__label{
            margin-bottom: 4px !important;
            font-size: 15px !important;
            font-weight: 700;
        }   
    }
</style>


<script>
    import baseFormItem from "./BaseFormItem"

    export default {
        name:"qweForm",
        mixins:[baseFormItem]
    }
</script>